import {
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  Stack,
} from '@mui/material';
import useI18n, { Ti18nId } from 'hooks/useI18n';
import { IFormRegister } from 'routes/Main/type';
import Form from 'components/Form';

interface Props extends RadioGroupProps, IFormRegister {
  i18nKey?: string;
  i18nNullKey?: string;
  value?: number;
  values: number[];
  defaultValue: number;
  disabled?: boolean;
  width?: string;
  direction?: string;
  whiteSpace?: string;
  onChange?: (value: any) => void;
}

const VAECMO_1_Row = ({
  i18nKey,
  i18nNullKey,
  values,
  defaultValue,
  disabled,
  width,
  whiteSpace,
  direction,
  onChange,
  register,
  ...props
}: Props) => {
  const i18n = useI18n();
  const label = (value: number) => {
    if (!value && i18nNullKey) return i18n(i18nNullKey as Ti18nId);
    if (i18nKey) return i18n(`${i18nKey}.${value}` as Ti18nId);
    return '';
  };

  return (
    <RadioGroup
      row
      defaultValue={defaultValue}
      sx={{
        flexWrap: 'wrap',
        whiteSpace: 'pre-wrap',
        display: 'flex',
        width: '1100px',
      }}
      onChange={(_, value) => onChange && onChange(value)}
      {...props}
    >
      {values.map(value => {
        if (value === 0) {
          return (
            <Stack direction="row">
              <FormControlLabel
                key={value}
                value={value}
                disabled={disabled}
                control={<Radio size="small" />}
                label={label(value)}
                sx={{ width: '100px' }}
              />
              <Form.MuiTextField
                {...register('treatment_reason.va_shock_reason_input')}
                required={false}
                disabled={disabled}
                placeholder="직접 입력"
                sx={{ width: '150px' }}
              />
            </Stack>
          );
        } else {
          return (
            <FormControlLabel
              key={value}
              value={value}
              disabled={disabled}
              control={<Radio size="small" />}
              label={label(value)}
              sx={{ width: '15vw', maxWidth: '240px', minWidth: '232px' }}
            />
          );
        }
      })}
    </RadioGroup>
  );
};

export default VAECMO_1_Row;
